module.exports = __webpack_public_path__ + "img/ems.7be78301.png";